import React from 'react'
import { default as TiposDeAporte } from '../container'
import { default as Content } from './content'

const Page = () => {
  return (
    <TiposDeAporte active={3}>
      <Content />
    </TiposDeAporte>
  )
}

export default Page
